// src/views/Posts/hooks/usePostList.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { handleApiError } from '../utils/errorHandler';

export const usePostList = (userId, showAllPosts) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPosts = async () => {
    try {
      const endpoint = showAllPosts
        ? `${process.env.REACT_APP_API_URL}posts/list/${userId}/`
        : `${process.env.REACT_APP_API_URL}posts/list/${userId}/all/`;
      const response = await axios.get(endpoint, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      setPosts(response.data);
      console.log('total number of posts:', response.data.count);
      setLoading(false);
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPosts();
  }, [userId, showAllPosts]);

  return { posts, loading, setPosts, loadPosts };
};
